import { clsx } from 'clsx';
import type { CharacterReadiness } from '../../hooks/useCharacterReadiness';
import { CheckIcon } from '../ui/Icons';

interface ReadinessProgressBarProps {
  readiness: CharacterReadiness;
}

export function ReadinessProgressBar({ readiness }: ReadinessProgressBarProps) {
  const { requiredComplete, requiredTotal, percentage, isReady } = readiness;

  // Color based on required item count: 0-2 red, 3-4 amber, 5 green
  const barColor = isReady
    ? 'bg-success'
    : requiredComplete >= 3
      ? 'bg-warning'
      : 'bg-danger';

  return (
    <div className="flex items-center gap-3 px-1 py-2">
      {/* Progress track */}
      <div className="flex-1 h-2 rounded-full bg-background-elevated overflow-hidden">
        <div
          className={clsx('h-full rounded-full transition-all duration-500 ease-out', barColor)}
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Status text */}
      {isReady ? (
        <span className="flex items-center gap-1 text-sm font-medium text-success whitespace-nowrap animate-pulse">
          <CheckIcon className="w-4 h-4" />
          Ready to Play
        </span>
      ) : (
        <span className="text-sm text-text-muted whitespace-nowrap">
          {requiredComplete}/{requiredTotal} Required
        </span>
      )}
    </div>
  );
}
